// // SLICK CAROUSEL
// $(document).ready(function(){

//   var sliderType = $(".slider");

//   sliderType.each(function() {
//     if ($(this).is(".single-item")) {
//       $(this).slick({
//         dots: true,
//         fade: true,
//         speed: 150,
//         arrows: true,
//         nextArrow: "<button type='button' class='slick-next'><span></span><span></span></button>",
//         prevArrow: "<button type='button' class='slick-prev'><span></span><span></span></button>",
//       });
//     }
//   })
// });


// $(document).ready(function(){
//   // SLICK CAROUSEL ARROW ROTATE (NEXT)
//   $('body').on('click', '.slick-next', function() {	

//     $(this).find('span:first-child').css(
//       "animation", "slickArrowRotateA .5s"
//     )

//     $(this).find('span:last-child').css(
//       "animation", "slickArrowRotateB .5s"
//     )

//     var clickedElement = $(this),  
//         newone = clickedElement.clone(true);

//     clickedElement.before(newone);

//     $(this).remove();       

//   });
// });


// $(document).ready(function(){
//   // SLICK CAROUSEL ARROW ROTATE (PREV)
//   $('body').on('click', '.slick-prev', function() {	

//     $(this).find('span:first-child').css(
//       "animation", "slickArrowRotateB .5s"
//     )

//     $(this).find('span:last-child').css(
//       "animation", "slickArrowRotateA .5s"
//     )

//     var clickedElement = $(this),  
//         newone = clickedElement.clone(true);

//     clickedElement.before(newone);

//     $(this).remove();       

//   });
// });


// SLICK CAROUSEL
$(document).ready(function(){

  var sliderType = $(".slider");

  sliderType.each(function() {
    if ($(this).is(".single-item")) {
      $(this).slick({
        dots: true,
        fade: true,
        speed: 150,
        arrows: true,
        nextArrow: "<button type='button' class='slick-next'><span></span><span></span></button>",
        prevArrow: "<button type='button' class='slick-prev'><span></span><span></span></button>",
      });
    }
    else if ($(this).is(".autoplay")){
      $(this).slick({
	  	autoplay: true,
	  	fade: true,
	  	autoplaySpeed: 2500,
	    speed: 500,
	    cssEase: 'ease-in-out',
		pauseOnHover: false,
		arrows: false,
      });
    }
    else if ($(this).is(".multiple-items")){
      $(this).slick({
        infinite: true,
        centerMode: true,
        centerPadding: 0,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        easing: 'easeOutElastic',
        nextArrow: "<button type='button' class='slick-next'><span></span><span></span></button>",
        prevArrow: "<button type='button' class='slick-prev'><span></span><span></span></button>",
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
        ]
      });
    }
    else if ($(this).is(".multiple-items-autoplay")){
      $(this).slick({
      	autoplay: true,
	  	autoplaySpeed: 3000,
	    speed: 1500,
	    cssEase: 'ease-in-out',
		pauseOnHover: false,
      	infinite: true,
        slidesToShow: 3,
	    slidesToScroll: 1,
		arrows: true,
		initialSlide: 0,
		nextArrow: "<button type='button' class='slick-next'><span></span><span></span></button>",
		prevArrow: "<button type='button' class='slick-prev'><span></span><span></span></button>",
		responsive: [
		{
		  breakpoint: 1280,
		  settings: {
	        slidesToShow: 2,
		    slidesToScroll: 1,
		    initialSlide: 2,
		  }
		},
		{
		  breakpoint: 768,
		  settings: {
	        slidesToShow: 1,
		    slidesToScroll: 1,
		    initialSlide: 3,
		  }
		},
		]
      });
    }
    else if ($(this).is(".variable-width")){
      $(this).slick({
        dots: true,
        infinite: true,
        speed: 300,
        centerMode: true,
        slidesToShow: 1,
        variableWidth: true,
        nextArrow: "<button type='button' class='slick-next'><span></span><span></span></button>",
        prevArrow: "<button type='button' class='slick-prev'><span></span><span></span></button>",
      });
    }
    else if ($(this).is(".thumbnails-upper")){
      $(this).slick({
	 	fade: true,
	 	arrows: false,
	 	asNavFor: '.thumbnails-lower',
      });
    }
    else if ($(this).is(".thumbnails-lower")){
      $(this).slick({
        infinite: true,
	 	variableWidth: true,
	 	focusOnSelect: true,
	 	asNavFor: '.thumbnails-upper',
		nextArrow: "<button type='button' class='slick-next'><span></span><span></span></button>",
		prevArrow: "<button type='button' class='slick-prev'><span></span><span></span></button>",
      });
    }
    else {
      $(this).slick();
    }
  })
});


$(document).ready(function(){
          
  // SLICK CAROUSEL ARROW ROTATE (NEXT)
  $('body').on('click tap', '.slick-next', function() {		

    $(this).find('span:first-child').css(
      "animation", "slickArrowRotateA .5s"
    )

    $(this).find('span:last-child').css(
      "animation", "slickArrowRotateB .5s"
    )

    var clickedElement = $(this),  
        newone = clickedElement.clone(true);

    clickedElement.before(newone);

    $(this).remove();       

  });



  // SLICK CAROUSEL ARROW ROTATE (PREV)
  $('body').on('click tap', '.slick-prev', function() {		

    $(this).find('span:first-child').css(
      "animation", "slickArrowRotateB .5s"
    )

    $(this).find('span:last-child').css(
      "animation", "slickArrowRotateA .5s"
    )

    var clickedElement = $(this),  
        newone = clickedElement.clone(true);

    clickedElement.before(newone);

    $(this).remove();       

  });
});